import * as React from 'react'

export function Dashboard () {
  return (
    <div>
      <h1>Dashboard</h1>
      <hr className='clear' />
      Coming soon
    </div>
  )
}

export default Dashboard
